export type AchievementI18nSource = {
  key?: string | null;
  name?: string | null;
  description?: string | null;
};

function translatedOrFallback(
  t: (key: string) => string,
  i18nKey: string,
  fallback: string
): string {
  const value = t(i18nKey);
  if (!value || value === i18nKey) return fallback;
  return value;
}

export function achievementCriteriaKey(achievement: AchievementI18nSource): string {
  return typeof achievement.key === 'string' ? achievement.key : '';
}

export function localizeAchievementName(
  t: (key: string) => string,
  achievement: AchievementI18nSource
): string {
  const key = achievementCriteriaKey(achievement);
  const fallback = achievement.name || '';
  if (!key) return fallback;
  return translatedOrFallback(t, `achievements.items.${key}.name`, fallback);
}

export function localizeAchievementDescription(
  t: (key: string) => string,
  achievement: AchievementI18nSource
): string {
  const key = achievementCriteriaKey(achievement);
  const fallback = achievement.description || '';
  if (!key) return fallback;
  return translatedOrFallback(t, `achievements.items.${key}.description`, fallback);
}
